import { Box } from "@mui/material";
import React from "react";

const Matrix = ({ size, displaySpread, getCard }: { size: number, displaySpread: boolean, getCard: (index: number) => React.ReactNode }) => {
    return (
        <div>Pyramid</div>
    )
}

export default Matrix;